'use es6';

import { getPortalIsInTBPilot } from 'pricing-pages-lib/api/TBPilotStatusApi';
import makeFetchRequest from './makeFetchRequest';
import { createRequestActions, createRequestTypes } from './RequestActions';
export const FetchTBPilotStatusRequestTypes = createRequestTypes('TB_PILOT_STATUS');
export const FetchTBPilotStatusActions = createRequestActions(FetchTBPilotStatusRequestTypes);
export const fetchTBPilotStatus = () => dispatch => {
  return makeFetchRequest({
    requestActions: FetchTBPilotStatusActions,
    fetch: getPortalIsInTBPilot
  })(dispatch);
};